import { render } from "./authData.vue?vue&type=template&id=59c8470f&ts=true"
import script from "./authData.vue?vue&type=script&lang=ts"
export * from "./authData.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\equistasi\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__